import React from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { Button } from '../components/Layout/Elements';

export const ErrorPage = () => {
  let history = useHistory();
  return (
    <ErrorWrapper>
      <h1>404</h1>
      <h3>Dead end</h3>
      <Button className='mt-2' onClick={() => history.push('/')} bg='var(--navbar-bg)' width='100%' maxWidth='300px' padding='10px' radius='40px' color='white' fontWeight='bold' fontSize='13px' to="/">
        Return to homepage
      </Button>
    </ErrorWrapper>
  );
};

const ErrorWrapper = styled.div`


  width: 100%;
  text-align: center;
  margin-top: 100px;
  margin-bottom: 200px;


  h1 {
    color: var(--productTitle);
    font-weight: bold;
    font-size: 95px;
    letter-spacing: 5px;
    margin-bottom: 20px;
  }

  h3 {
    color: var(--productTitle);
    font-weight: bold;
    font-size: 40px;
  }
`;

export { ErrorPage as default };
